import NetworkService from "./NetworkService";

export default class SurveyAdminService extends NetworkService {
  constructor() {
    super();
    this.endpoints.surveys = "api/admin/surveys";
  }

  audienceOptions() {
    return this.get(`${this.endpoints.surveys}/audience/options`);
  }
  audiencePreview(filters) {
    return this.post(`${this.endpoints.surveys}/audience/preview`, filters);
  }
  list(params) {
    return this.get(this.endpoints.surveys, params);
  }
  create(payload) {
    return this.post(this.endpoints.surveys, payload);
  }
  update(uuid, payload) {
    return this.put(`${this.endpoints.surveys}/${uuid}`, payload);
  }
  destroy(uuid) {
    return super.delete(`${this.endpoints.surveys}/${uuid}`);
  }
  show(uuid) {
    return this.get(`${this.endpoints.surveys}/${uuid}`);
  }
  send(uuid) {
    return this.post(`${this.endpoints.surveys}/${uuid}/send`);
  }
  close(uuid) {
    return this.post(`${this.endpoints.surveys}/${uuid}/close`);
  }
  recipients(uuid, params) {
    return this.get(`${this.endpoints.surveys}/${uuid}/recipients`, params);
  }
  userLink(uuid, userId) {
    return this.get(`${this.endpoints.surveys}/${uuid}/users/${userId}/link`);
  }
  results(uuid) {
    return this.get(`${this.endpoints.surveys}/${uuid}/results`);
  }
}
